import { render, staticRenderFns } from "./CheckpointMicrolearningVideoCard.vue?vue&type=template&id=5e234eeb&scoped=true"
import script from "./CheckpointMicrolearningVideoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointMicrolearningVideoCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointMicrolearningVideoCard.vue?vue&type=style&index=0&id=5e234eeb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e234eeb",
  null
  
)

export default component.exports